<template>
    <div class="messageBox">
        <div class="header">{{ this.header }}</div>
      <p>
          {{ this.info }}
      </p>
      <p> 
          {{ this.question }}
      </p>
      <footer>

    <b-button 
        v-if="question"
        variant="danger" 
        @click="action()"
        :title="$t('confirmar')"
        :alt="$t('confirmar')" >
        
        {{ $t('yes') }}
    </b-button>

    <b-button  
        v-if="question"
        :title="$t('cancelar')"
        :alt="$t('cancelar')"
        @click="close()"
        >
        {{ $t('nao') }}
    </b-button>

    <b-button  
        v-if="info"
        :title="$t('cancelar')"
        :alt="$t('cancelar')"
        @click="close()"
        >
        {{ $t('ok') }}
    </b-button>
      </footer>
    </div>
</template>

<script>
    export default {
        props: [ "header", "info", "question", "action", "open", "cancelAction" ],

        watch:{
            open(){
                document.querySelector(".messageBox").style.display = "flex";
            }
        },

        methods: {
            close() {
                document.querySelector(".messageBox").style.display = "none";
                if (this.cancelAction)
                    this.cancelAction();
            }
        },
    }
</script>

<style scoped>

.messageBox {
    padding: 0;
    margin: 0;
    border: none;
    display: flex; 
    flex-direction: column;
    justify-content: space-between;
    width: 500px;
    position: absolute;
    top: calc(50% - 100px);
    left: calc(50% - 250px);
    border-radius: 7px;
    font-size: 1.1em;
    background-color: #fff;
    box-shadow: 3px 5px 5px #555;
    border: 1px solid #ccc;
    z-index: 10;
}

.messageBox>p{
    text-align: center;
    padding: 10px 10px 0 10px;
    margin: 0;
    overflow: auto;
}

.messageBox>p:nth-child(3){
    padding: 0px 10px 10px 10px;
}

.header {
    border-top-right-radius: 7px;
    border-top-left-radius: 7px;
    margin: 0;
    border-bottom: 1px solid #ccc;
    padding: 2px 15px;
    text-align: left;
    font-size: 1.15em;
    widows: 100%;
}



footer{
    margin-top: 10px;
    border-top: 1px solid #ccc;
    flex-direction: row;
    padding-right: 10px;
}

button {
    cursor: pointer;
    float: right;
    width: 60px;
    margin: 5px 7px 5px 0;
}

button:nth-child(1){
    margin: 5px 5px 5px 0;
}

@media (max-width: 550px) { 
    .messageBox {
    width: 330px;
    top: calc(50% - 100px);
    left: calc(50% - 165px);
    }

    .messageBox>p{
        padding: 5px;
    }
}

</style>